/**
 * Icons by file type, as a MIME type or a bare extension. A Map rather than an
 * object, so only these exact values match and nothing inherited does.
 */
const FILE_TYPE_ICONS = new Map<string, string>([
  ["application/pdf", "vscode-icons:file-type-pdf2"],
  ["pdf", "vscode-icons:file-type-pdf2"],

  ["png", "vscode-icons:file-type-image"],
  ["image/png", "vscode-icons:file-type-image"],

  ["docx", "vscode-icons:file-type-word"],
  ["application/msword", "vscode-icons:file-type-word"],
  [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "vscode-icons:file-type-word",
  ],

  ["xlsx", "vscode-icons:file-type-excel"],
  ["application/vnd.ms-excel", "vscode-icons:file-type-excel"],
  [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "vscode-icons:file-type-excel",
  ],

  ["pptx", "vscode-icons:file-type-powerpoint"],
  ["application/vnd.ms-powerpoint", "vscode-icons:file-type-powerpoint"],
  [
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "vscode-icons:file-type-powerpoint",
  ],

  // Google Workspace file types (branded SVG icons for main types, simple-icons fallback for rare types)
  ["application/vnd.google-apps.document", "/icons/google/docs.svg"],
  ["application/vnd.google-apps.spreadsheet", "/icons/google/sheets.svg"],
  ["application/vnd.google-apps.presentation", "/icons/google/slides.svg"],
  ["application/vnd.google-apps.folder", "/icons/google/drive.svg"],
  ["application/vnd.google-apps.form", "/icons/google/forms.svg"],
  ["application/vnd.google-apps.drawing", "simple-icons:googledrive"],
  ["application/vnd.google-apps.map", "simple-icons:googlemaps"],
  ["application/vnd.google-apps.script", "simple-icons:googleappsscript"],
  ["application/vnd.google-apps.site", "simple-icons:google"],
  ["application/vnd.google-apps.jam", "simple-icons:google"],

  // Text formats
  ["text/markdown", "vscode-icons:file-type-markdown"],
  ["text/x-markdown", "vscode-icons:file-type-markdown"],
  ["text/plain", "vscode-icons:file-type-text"],
  ["text/csv", "vscode-icons:file-type-csv"],
  ["application/json", "vscode-icons:file-type-json"],
]);

export const convertFileTypeToIcon = (fileType: string) => {
  fileType = fileType.toLowerCase();
  if (fileType.startsWith("image/")) {
    return "material-icon-theme:image";
  }

  return FILE_TYPE_ICONS.get(fileType) ?? "vscode-icons:default-file";
};
